import React, { useEffect, useRef, useState } from "react";
import { classRoom } from "../../../core/data/json/class-room";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  capacitycount,
  count,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import { Link, useNavigate } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import UserService from "../../network/services/UserService";
import { Modal, Toast } from "react-bootstrap";
import { getUser } from "../../network/auth/Auth";

const ClassRoom = () => {
  const routes = all_routes;



  interface classroomData {
    id: any,
    name: any,
    code: any,
    capacity: any,
    active: any,
    batch_id: any
  }
  interface Option {
    id: any;
    name: any;
  }
  interface CourseData {
    id: any;
    name: any;
    code: any;
    parent_id: any;
    evaluation_type: any;
    subject_ids: any;
    department_id: any;
    active: any;
    fees_term_id: any;
    operating_branch_id: any;
    company_id: any

  }
  interface OpBatchData {
    id: any;
    name: any;
  }


  const [classrooms, setClassrooms] = useState<classroomData[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [branch, setBranch] = useState<Option>(getUser()?.company_ids[0]?.branches[0]);
  const branches = getUser()?.company_ids[0]?.branches;
  const [opbatchs, setOpbatchs] = useState<OpBatchData[]>([]);
  const [courses, setCourses] = useState<CourseData[]>([]);
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    capacity: '',
    active: '',
    course_id: '',
    batch_id: '',
    operating_branch_id: '',
  });
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    code: '',
    capacity: '',
    active: '',
    course_id: '',
    batch_id: '',
    operating_branch_id: '',
  });
  const fetchDataOpBatchs = async (course_id: any) => {
    UserService.getOpBatch(course_id, (response: any) => {
      if (response?.data && response?.success) {
        setOpbatchs(response.data);
      }
    });
  };

  const fetchDataCourse = async (company_id: any) => {
    UserService.getCourseByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setCourses(response.data);
      }
    });
  };


  useEffect(() => {
    fetchDataCourse(getUser()?.company_ids[0]?.id);
  }, []);


  const fetchData = async () => {
    UserService.getallClassroom((response: any) => {
      if (response?.data && response?.success) {
        setClassrooms(response.data);
      }
    });
  };

  useEffect(() => {
    fetchData()
  }, [])

  const navigation = useNavigate()

  const navigeClassroomDetails = (classroom_id: any) => {
    navigation(`/academic/class-room/${classroom_id.id}`)
  }

  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);





  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });


    if (name === "course_id") {
      fetchDataOpBatchs(value)

    }
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));

    if (name === "course_id") {
      fetchDataOpBatchs(value)

    }
  };

  const handleInputChangeEdite2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    const selectedBranch = branches.find((branch: any) => branch.id === parseInt(value, 10));

    if (selectedBranch) {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        operating_branch_id: [selectedBranch],
      }));
    }
  };
  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
    console.log(record.course_id[0]?.id)
    if (record?.course_id[0]?.id) {
      fetchDataOpBatchs(record.course_id[0]?.id)

    }

  };

  const handleSubmit = () => {
    setIsLoading(true);

    // Définir explicitement le type de request_data
    const request_data: {
      name: string;
      code: string;
      capacity: number | null;
      course_id: number | null;
      batch_id: number | null;
      operating_branch_id: number | null;
    } = {
      name: formData.name,
      code: formData.code,
      capacity: formData.capacity ? parseInt(formData.capacity, 10) : null,
      course_id: formData.course_id ? parseInt(formData.course_id, 10) : null,
      batch_id: formData.batch_id ? parseInt(formData.batch_id, 10) : null,
      operating_branch_id: formData.operating_branch_id
        ? parseInt(formData.operating_branch_id, 10)
        : getUser()?.company_ids[0]?.branches[0]?.id || null,
    };

    // Vérification des champs requis
    const requiredFields: (keyof typeof request_data)[] = ['name', 'code', 'capacity', 'course_id', 'batch_id', 'operating_branch_id'];
    const areAllFieldsFilled = requiredFields.every((field) => request_data[field] !== null && request_data[field] !== '');

    if (!areAllFieldsFilled) {
      setIsLoading(false);
      setErrorMessage('Please fill in all required fields.');
      setShowDangerToast(true);
      return;
    }

    console.log(request_data);

    UserService.addAddClassrooms(request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData();
        setIsLoading(false);
        setSuccessMessage('Data saved successfully');
        setShowSuccessToast(true);
        setFormData({
          name: '',
          code: '',
          capacity: '',
          active: '',
          course_id: '',
          batch_id: '',
          operating_branch_id: '',
        });
        setShowModal(false);
      } else {
        setErrorMessage('An error has occurred, please try again.');
        setShowDangerToast(true);
        setIsLoading(false);
      }
    });
  };



  const handleSubmitEdit = () => {


    setIsLoading(true)
    const request_data = {
      name: selectedRecord.name,
      code: selectedRecord.code,
      capacity: parseInt(selectedRecord.capacity, 10),


      course_id: Array.isArray(selectedRecord.course_id) ? parseInt(selectedRecord.course_id[0].id, 10) : parseInt(selectedRecord.course_id, 10),
      batch_id: Array.isArray(selectedRecord.batch_id) ? parseInt(selectedRecord.batch_id[0].id, 10) : parseInt(selectedRecord.batch_id, 10),
      operating_branch_id: selectedRecord?.operating_branch_id?.[0]?.id === undefined ? parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10) : parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10),
    };
    console.log(request_data)
    console.log(selectedRecord)


    UserService.editClassroom(selectedRecord?.id, request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData();
        setIsLoading(false)

        setFormData({
          name: '',
          code: '',
          capacity: '',
          active: '',
          course_id: '',
          batch_id: '',
          operating_branch_id: '',
        });
        handleClose2()
      } else {

        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };


  const data = classRoom;
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {record.id}
          </Link>
        </>
      ),
      sorter: (a: classroomData, b: classroomData) => a.id.length - b.id.length,
    },

    {
      title: "Room Name",
      dataIndex: "name",
      sorter: (a: classroomData, b: classroomData) => a.name.length - b.name.length,
    },
    {
      title: "Room Code",
      dataIndex: "code",
      sorter: (a: classroomData, b: classroomData) => a.code.length - b.code.length,
    },
    {
      title: "Capacity",
      dataIndex: "capacity",
      sorter: (a: classroomData, b: classroomData) =>
        a.capacity.length - b.capacity.length,
    },
    {
      title: "Batch",
      render: (record: any) => (
        <>
          <span className="align-items-center">
            {record?.batch_id[0]?.name}
          </span>
        </>
      ),
      sorter: (a: any, b: any) => a.active.length - b.active.length,
    },
    {
      title: "Active",
      render: (record: any) => (
        <>
          {record.active ? (<span className="badge badge-soft-success d-inline-flex align-items-center">
            <i className="ti ti-circle-filled fs-5 me-1"></i>Active
          </span>) : (<span className="badge badge-soft-danger d-inline-flex align-items-center">
            <i className="ti ti-circle-filled fs-5 me-1"></i>Inactive
          </span>)}
        </>
      ),
      sorter: (a: any, b: any) => a.active.length - b.active.length,
    },
    {
      title: "Action",
      render: (record: any) => (
        <>
          <div className="dropdown">
            <Link
              to="#"
              className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="ti ti-dots-vertical fs-14" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-right p-3">
              <li>
                <a
                  className="dropdown-item rounded-1"

                  onClick={() => navigeClassroomDetails(record)}
                >
                  <i className="ti ti-edit-circle me-2" />
                  View
                </a>
              </li>
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  onClick={() => handleEdit(record)}
                >
                  <i className="ti ti-edit-circle me-2" />
                  Edit
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-modal"
                >
                  <i className="ti ti-trash-x me-2" />
                  Delete
                </Link>
              </li>
            </ul>
          </div>
        </>
      ),
    },
  ];
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Class </h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Academic </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Class
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                <TooltipOption />
                <div className="mb-2">
                  <Link
                    to="#"
                    className="btn btn-primary"
                    onClick={handleShow}
                  >
                    <i className="ti ti-square-rounded-plus-filled me-2" />
                    Add Class
                  </Link>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            {/* Guardians List */}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                <h4 className="mb-3">Class </h4>
                <div className="d-flex align-items-center flex-wrap">
                  <div className="input-icon-start mb-3 me-2 position-relative">
                    <PredefinedDateRanges />
                  </div>
                  <div className="dropdown mb-3 me-2">
                    <Link
                      to="#"
                      className="btn btn-outline-light bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                    >
                      <i className="ti ti-filter me-2" />
                      Filter
                    </Link>
                    <div
                      className="dropdown-menu drop-width"
                      ref={dropdownMenuRef}
                    >
                      <form>
                        <div className="d-flex align-items-center border-bottom p-3">
                          <h4>Filter</h4>
                        </div>
                        <div className="p-3 border-bottom pb-0">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">Room No</label>
                                <CommonSelect
                                  className="select"
                                  options={count}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">Capacity</label>
                                <CommonSelect
                                  className="select"
                                  options={capacitycount}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="p-3 d-flex align-items-center justify-content-end">
                          <Link to="#" className="btn btn-light me-3">
                            Reset
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={handleApplyClick}
                          >
                            Apply
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="dropdown mb-3">
                    <Link
                      to="#"
                      className="btn btn-outline-light bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-sort-ascending-2 me-2" />
                      Sort by A-Z
                    </Link>
                    <ul className="dropdown-menu p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1 active">
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Descending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Recently Viewed
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Recently Added
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body p-0 py-3">
                {/* Guardians List */}
                <Table columns={columns} dataSource={classrooms} Selection={true} />

                {/* /Guardians List */}
              </div>
            </div>
            {/* /Guardians List */}
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
      <div>
        {/* Add Class Room */}
        <div className="modal fade" id="add_class_room">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Class Room</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Room No</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Capacity</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-primary" data-bs-dismiss="modal">
                    Add Class Room
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Class Room */}
        {/* Edit Class Room */}
        <div className="modal fade" id="edit_class_room">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Class Room</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Room No</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Room no"
                          defaultValue={110}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Capacity</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Capacity"
                          defaultValue={50}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-primary" data-bs-dismiss="modal">
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Class Room */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form >
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}





        <Modal show={showModal} onHide={handleClose} size={"xl"}>
          <Modal.Header >
            <Modal.Title>Add Class rooms</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form >
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">	Principal Room </label>
                      <select

                        className="select react-select form-control"
                        name="course_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Principal Room </option>
                        {courses && courses?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">	Batch</label>
                      <select

                        className="select react-select form-control"
                        name="batch_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Batch</option>
                        {opbatchs && opbatchs?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Room Name</label>
                      <input type="text" className="form-control" placeholder="name" name="name" onChange={handleInputChange} />
                    </div>

                  </div>

                  <div className="col-md-6">

                    <div className="mb-3">
                      <label className="form-label">Room Code</label>
                      <input type="text" className="form-control" placeholder="code" name="code" onChange={handleInputChange} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Capacity</label>
                      <input type="number" className="form-control" placeholder="capacity" name="capacity" onChange={handleInputChange} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Branch</label>
                      <select

                        className="select react-select form-control"
                        name="operating_branch_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Branch</option>
                        {branches && branches?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>

                  </div>

                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <a className="btn btn-primary" onClick={handleSubmit}  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Add Class Room"}

                </a>

              </div>
            </form>
          </Modal.Body>

        </Modal>



        <Modal show={showModal2} onHide={handleClose2} size={"xl"}>
          <Modal.Header >
            <Modal.Title>Edit Class rooms</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose2}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form >
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">	Principal Room </label>
                      <select

                        className="select react-select form-control"
                        name="course_id"
                        value={selectedRecord.course_id?.[0]?.id}
                        onChange={handleInputChangeEdite}
                      >
                        <option >Select Principal Room </option>
                        {courses && courses?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">	Batch</label>
                      <select

                        className="select react-select form-control"
                        name="batch_id"
                        value={selectedRecord.batch_id?.[0]?.id}
                        onChange={handleInputChangeEdite}
                      >
                        <option >Select Batch</option>
                        {opbatchs && opbatchs?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Room Name</label>
                      <input type="text" className="form-control" placeholder="name" name="name" value={selectedRecord.name} onChange={handleInputChangeEdite} />
                    </div>

                  </div>

                  <div className="col-md-6">

                    <div className="mb-3">
                      <label className="form-label">Room Code</label>
                      <input type="text" className="form-control" placeholder="code" name="code" value={selectedRecord.code} onChange={handleInputChangeEdite} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Capacity</label>
                      <input type="number" className="form-control" placeholder="capacity" name="capacity" value={selectedRecord.capacity} onChange={handleInputChangeEdite} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Branch</label>
                      <select

                        className="select react-select form-control"
                        name="operating_branch_id"
                        value={selectedRecord?.operating_branch_id?.[0]?.id || ''}// Assurez-vous que cette valeur correspond à une option
                        onChange={handleInputChangeEdite2}
                      >
                        <option >Select Branch</option>
                        {branches && branches?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>

                  </div>

                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <a className="btn btn-primary" onClick={handleSubmitEdit}  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Edit Class Room"}

                </a>

              </div>
            </form>
          </Modal.Body>

        </Modal>


        <Toast
          show={showDangerToast}
          onClose={handleDangerToastClose}
          id="dangerToast"
          className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ minWidth: "200px!important" }}
        >
          <Toast.Header closeButton className="bg-danger text-fixed-white">
            <strong className="me-auto">Message</strong>
            <span
              className="cursor-pointer"
              onClick={handleDangerToastClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </Toast.Header>
          <Toast.Body>
            {/* Add your toast content here */}
            {errorMessage}
          </Toast.Body>
        </Toast>

        <Toast
          show={showSuccessToast}
          onClose={handleSuccessToastClose}
          id="successToast"
          className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >

          <Toast.Body>
            {/* Add your toast content here */}
            {successMessage}
          </Toast.Body>
        </Toast>
      </div>
    </div>
  );
};

export default ClassRoom;
